import React, { FC } from 'react';
import styled from 'styled-components';

interface StyleButtonProps {
  backgroundColor: string;
  borderColor: string;
  color: string;
  fontSize: string;
  borderRadius: string;
  height: string;
  padding: string;
  gap: number;
  fontWeight: number;
  customFloat: string;
  mt: string;
  mb: string;
  ml: string;
  mr: string;
}
interface Props {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  renderIcon: React.JSX.Element;
  fullWidth: boolean;
  style: Partial<StyleButtonProps>;
  isLoading: boolean;
  posLeft: boolean;
  [rest: string]: any;
}

export const StyledButton = styled.button<{
  style?: Partial<StyleButtonProps>;
  fullWidth?: boolean;
}>`
  background-color: ${(props) => props.style?.backgroundColor || '#6DCD90'};
  border-color: ${(props) => props.style?.borderColor || '#6DCD90'};
  color: ${(props) => props.style?.color || '#fff'};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${(props) => `${props.style?.gap}px` || ''};
  font-size: ${(props) => props.style?.fontSize || '14px'};
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  border: ${(props) => props.style?.border || '1px solid transparent'};
  border-radius: ${(props) => props.style?.borderRadius || '6px'};
  height: ${(props) => props.style?.height || '40px'};
  width: ${(props) => (props.fullWidth ? '100%' : '')};
  padding: ${(props) => props.style?.padding || '0 14px'};
  font-weight: ${(props) => props.style?.fontWeight || 700};
  float: ${(props) => props.style?.customFloat || ''};

  margin-top: ${(props) => props.style?.mt || ''};
  margin-bottom: ${(props) => props.style?.mb || ''};
  margin-left: ${(props) => props.style?.ml || ''};
  margin-right: ${(props) => props.style?.mr || ''};
  @media (max-width: 766px) {
    width: 100%;
  }
`;

export const Wrapper = styled.div``;
export const Button: FC<Partial<Props>> = ({
  onClick,
  children,
  renderIcon,
  style,
  fullWidth,
  isLoading,
  posLeft,
  ...rest
}) => {
  return (
    <Wrapper>
      <StyledButton
        disabled={isLoading}
        fullWidth={fullWidth}
        style={style}
        onClick={onClick}
        {...rest}
      >
        <>
          {posLeft && renderIcon}
          {children}
          {!posLeft && renderIcon}
        </>
      </StyledButton>
    </Wrapper>
  );
};
